import List from "../components/list";
import ListItem from "../components/list-item";
import Modal from "../components/modal";
import { PageContent, ContentType } from "../models/page";

function getDefaulValueForType(type: ContentType) {
		switch (type) {
				case "section":
						return [];
				case "button":
						return {
								text: "",
								target: ""
						};
				case "columns":
						return [[], []];
				case "faq":
						return [{
								question: "",
								answer: ""
						}];
				case "heading":
						return "";
				case "text":
						return "";
				case "image":
						return {
								src: "",
								alt: ""
						};
				case "image-with-text":
						return {
								src: "",
								alt: "",
								text: ""
						};
				case "table":
						return [];
				default:
						return null;
		}
}

export default function AddContentModal(props: {close: () => void, addContent: (c: PageContent) => void, nested?: boolean}) {

		const select = (type: ContentType) => () => {
				props.addContent({type, value: getDefaulValueForType(type)});
				props.close();
		};

		return <Modal title="Neue Komponente" close={props.close}>
				<List>
						{!props.nested && <ListItem onClick={select("section")}>
								Sektion
						</ListItem>}
						<ListItem onClick={select("heading")}>
								Überschrift
						</ListItem>
						<ListItem onClick={select("text")}>
								Text
						</ListItem>
						<ListItem onClick={select("image")}>
								Bild
						</ListItem>
						<ListItem onClick={select("table")}>
								Tabelle
						</ListItem>
						<ListItem onClick={select("faq")}>
								FAQ
						</ListItem>
						<ListItem onClick={select("image-with-text")}>
								Bild mit Text
						</ListItem>
						<ListItem onClick={select("button")}>
								CTA Button
						</ListItem>
						<ListItem onClick={select("columns")}>
								Zwei Spalten
						</ListItem>
				</List>
		</Modal>
}